export default (props, vars) => vars?.['applicationcard2']?.['item'].job_name;
